import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const Breadcrumbs = ({ items }) => (
  <nav data-testid="breadcrumbs" aria-label="Breadcrumb" className="mb-6">
    <ol className="flex flex-wrap items-center gap-1.5 text-xs font-medium uppercase tracking-[0.15em] text-muted2">
      {items.map((it, i) => (
        <li key={it.path || it.name} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight className="h-3 w-3 text-muted2/50" aria-hidden="true" />}
          {it.path && i < items.length - 1 ? (
            <Link to={it.path} className="transition-colors hover:text-bronze">{it.name}</Link>
          ) : (
            <span className={i === items.length - 1 ? 'text-ink' : ''} aria-current={i === items.length - 1 ? 'page' : undefined}>{it.name}</span>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export default Breadcrumbs;
